import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import { OverlayType } from "../../../vendor_core/core/src/server/data/ISpinData";
import { ICondition } from "../../../vendor_core/core/src/states/State";


export default class BBHasMoveDataCondition implements ICondition {
    public check(): boolean {
        let currentGeneration: any = SpinModel.cascades[SpinModel.cascadeIndex];
        let hasExplodedSymbols = SpinModel.getCurrentSpinProperty("cascadeExplodesOffsets")?.length > 1;

        return currentGeneration && currentGeneration.transform && currentGeneration.transform.length > 0 && !hasExplodedSymbols

    }
}
